/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Relativejustnow2Inputs */

const en_relativejustnow2 = /** @type {(inputs: Relativejustnow2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`just now`)
};

const pt_relativejustnow2 = /** @type {(inputs: Relativejustnow2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`agora mesmo`)
};

/**
* | output |
* | --- |
* | "just now" |
*
* @param {Relativejustnow2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const relativejustnow2 = /** @type {((inputs?: Relativejustnow2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Relativejustnow2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_relativejustnow2(inputs)
	return pt_relativejustnow2(inputs)
});
export { relativejustnow2 as "relativeJustNow" }